
















import { Component, Vue } from 'vue-property-decorator';
import FormHeader from '@/app/common/component/FormHeader.vue';
import RegisterForm from '@/app/auth/register/RegisterForm.vue';
import HeaderImg from '@/app/common/component/HeaderImg.vue';
import ILanguage from '@/app/common/model/ILanguage';
import LanguageService from '@/app/common/service/LanguageService';
import ICountry from '@/app/common/model/ICountry';
import IRegisterForm from '@/app/auth/register/IRegisterForm';
import AuthService from '@/app/common/service/AuthService';
import NotificationService from '@/app/common/service/NotificationService';
import StorageRepository from '@/app/common/repository/StorageRepository';

@Component({
  name: 'RegisterContainer',
  components: { FormHeader, RegisterForm, HeaderImg },
})
export default class RegisterContainer extends Vue {
  public countryList: ICountry[] = [];

  private mounted() {
    this.getCountryList();
  }

  get languageList(): ILanguage[] {
    return this.$store.getters.languageList;
  }

  get recaptcha(): string | null {
    return this.$store.getters.recaptcha;
  }

  get logoUrl(): string | null {
    return this.$store.getters.logoUrl;
  }

  public async getCountryList() {
    try {
      this.countryList = await LanguageService.getCountryList();
    } catch (e) {
      NotificationService.error(e);
    }
  }

  public async onRegister(api: IRegisterForm): Promise<void> {
    try {
      await AuthService.registerUser(api);
      await this.$router.push({name: 'AfterRegister'});
    } catch (e) {
      NotificationService.error(e);
    }
  }
}
